module.exports = __webpack_public_path__ + "assets/images/amira_pd_default.44570003bbac3125698764d59d5bd11e.svg";